import { Button } from "antd"
import { useNavigate } from "react-router"
import UserCan from "../../../components/UserCan"
const NowyWpisButton = () => {
    const navigate = useNavigate()
    return <UserCan perms={['can_add_new_wplyw']}><Button style={{height: '45px', flex: 'none', fontSize: '18px'}} type="primary" onClick={() => navigate('/wplywy/nowy')}>Nowy wpływ</Button></UserCan>
}

export default NowyWpisButton